import type { GetProjectInformationResponse } from "@nlc/shared-types";

import { useQuery } from "@tanstack/react-query";

import { projectInformationKeys } from "@/hooks/queryKeys";
import { useIsTemplate } from "@/hooks/useIsTemplate.tsx";
import apiClient from "@/lib/api/client";

export function useProjectInformation(projectId?: number) {
  const { isTemplate } = useIsTemplate();

  return useQuery({
    enabled: !isTemplate && !!projectId,
    queryFn: () =>
      apiClient
        .url(`/projects/${projectId}/project-information`)
        .get()
        .json<GetProjectInformationResponse>(),
    queryKey: projectInformationKeys.editPage(projectId),
  });
}
